import { useState, useEffect, useMemo, FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AddFeeModal, AddRequirementModal } from "../../molecules/AppModal";

// import { ReactComponent as LeftArrow } from "../../icons/ScrollLeftArrow.svg";
import { ReactComponent as BackButtonIcon } from '../../icons/BackButtonIcon.svg'
import { useLoadCurrentResource, useResourceHook, useLoadResourceOptions, useLoadRequirements } from "../../hooks/resourcehooks";
import { useLoadPlans } from "../../hooks/communityhook";
import { useLoadResourceBookings } from '../../hooks/memberhooks'
// import { useLoadRequests } from "../../hooks/memberhooks";
// import { useResourceState } from '../../contexts/kitchencontext';
// import { styleThousandCommas } from "../../utils/helpers";
import { ResourceType, SearchFilterOptionType, CommunityOptionType, ResourceSchema, WeekdayOptionFields, ResourceOptionsPropsType, RequirementSchema, FeeSchema, ResourceTabOptionType, DiscountSchema, ResourcePlanSchema, PlanRecurrenceOptions   } from "../../data/types";
import { capitalizeString, getChangedAttributes, styleThousandCommas, getPeriodStyles, planRecurrenceMap, planShowsFulltimeHoursBadge } from "../../utils/helpers";
import { ResourceInfoForm, ResourceImagesForm, ResourceRequirementsForm, ResourceFeesForm, ResourceDiscountsForm, ResourceRulesForm } from "../../molecules/forms";
import {
  buildInventoryItemsByIdFromResources,
  getInventorySelectionLabel,
  mergeResourcePlansWithDualTiers,
  planHasDisplayFeatures,
} from "../../molecules/forms/PlanTierResourceFeatures";
import { ResourceProductDetails } from "../../molecules/ResourceProduct";
import { AllResourceRequests, FundingPipelinePanel } from "../auth/RequestsPage";
import DocumentationStepsPanel from "../../components/documentation/DocumentationStepsPanel";
import DocumentationApplicantsPanel from "../../components/documentation/DocumentationApplicantsPanel";
import { AddDiscountModal, AddResourcePlanModal, DeleteConfirmationModal, EditResourcePlanModal } from "../../molecules/AppModal";
import LoadingScreen from "./LoadingScreen";
import { toast } from "sonner";
import { useAuthState } from '../../contexts/authcontext';
import { FINANCIAL_WHEEL_OPTIONS, FULFILLMENT_MODE_OPTIONS, getPartnerDisplayName, isAiriWheelsResource, isFinancialIntelligenceResource } from "../../utils/fundingPartners";
import { ContactProjectSummary, isContactBuilderResource } from "../../utils/contactBuilder";
import ContactBuilderOps from "../../components/ContactBuilderOps";
import DscvryMemberRequests from "../../components/DscvryMemberRequests";
import { listContactProjectSummaries } from "../../api/contactBuilder";
import { PilotScorecard } from '../../components/funding/PilotScorecard';
import { buildFundingPipelineItems } from "../../utils/fundingPipeline";
import { AddCircle, CheckCircle, ArrowOutward, ExpandLess, ExpandMore, Layers } from "@mui/icons-material";
// import ArrowOutwardIcon from '@mui/icons-material/';

import { ReactComponent as ClockIcon } from '../../icons/ClockIcon.svg'
import { ReactComponent as PlanIcon } from '../../icons/PlanIcon.svg'
import { ReactComponent as CopyIcon } from '../../icons/CopyIcon.svg'
import { ReactComponent as DeleteIcon } from '../../icons/DeleteIcon.svg'
import { ReactComponent as EditIcon } from '../../icons/EditIcon.svg'
import { ReactComponent as CommunityIcon } from '../../icons/CommunityIcon.svg'
import { ReactComponent as TagIcon } from '../../icons/TagIcon.svg'

import { ReactComponent as KitchenIcon } from '../../icons/KitchenIcon.svg'
import config from '../../config';


const resourcePantryUrl = config?.webUrl
// const openInNewTab = (url: string) => {
//   window.open(url, "_blank");
// };

type RouteParams = {
  resourceid: string;
  resourceType: ResourceType
};


type ResourceDetailsProps = {
  searchFilterOptions: SearchFilterOptionType
}
const ResourceDetails: React.FC<ResourceDetailsProps> = () => {

  const navigate = useNavigate()
  const { resourceid: routeResourceId, resourceType: routeResourceType } = useParams<RouteParams>();
  const resourceType: ResourceType = routeResourceType ?? 'kitchen';
  const resourceid = routeResourceId ?? '';
  const { currentResource, isLoadingResource } = useLoadCurrentResource(resourceid)

  // const handleReloadResource = async () => {
  //   await reloadCurrentResource()
  // }

  // const { memberships } = useLoadMemberships();
  // console.log("useLoadResourceBookings resourceid", resourceid)
  const { communityId } = useAuthState();
  const { resourceBookings: bookings } = useLoadResourceBookings(resourceid);

  
  
  const [currentOption, setCurrentOption] = useState<CommunityOptionType>({id: "details", name: `${resourceType ? capitalizeString(resourceType) : "Resource"} Details`});
  const [resource, setResource] = useState<ResourceSchema>(currentResource as ResourceSchema)
  const [memberLists, setMemberLists] = useState<ContactProjectSummary[]>([])
  const [isLoadingMemberLists, setIsLoadingMemberLists] = useState(false)
  const [opsProjectId, setOpsProjectId] = useState('')
  const resourceName = (resource && resource?.name) ? resource.name : "";
  const [isOpenAddPlan, setIsOpenPlan] = useState(false);
  const [isOpenEditPlan, setIsOpenEditPlan] = useState<{isOpen: boolean, plan: ResourcePlanSchema | null}>({isOpen: false, plan: null});
  const [isDuplicate, setIsDuplicate] = useState<{existingPlan: ResourcePlanSchema, checked: boolean}>({existingPlan: {} as ResourcePlanSchema, checked: false});
  const [isAddingCustomRequirement, setIsAddingCustomRequirement] = useState(false);
  const [isOpenFee, setIsOpenFee] = useState(false);
  const [isOpenDiscount, setIsOpenDiscount] = useState(false);
  const [isDeletingResource, setIsDeletingResource] = useState<boolean>(false)
  const [isDeletingDiscount, setIsDeletingDiscount] = useState<{isOpen: boolean, discountName: string}>({isOpen: false, discountName: ""})
  const [isDeletingFee, setIsDeletingFee] = useState<{isOpen: boolean, feeName: string}>({isOpen: false, feeName: ""})
  const { 
    updateResource, updateOptions, deleteResource, 
    addNewResourceFee, deleteExistingResourceFee, addNewResourceDiscount, 
    deleteExistingDiscount, updateResourcePlan, reloadCurrentResource,
    isError: isResourceError } = useResourceHook({resourceId: resourceid, resourceType})
  const { requirements, addCustomRequirement, isError: isReqError} = useLoadRequirements()
  const { updateCommunityPlan } = useLoadPlans()


  // const { isLoading, addNewResourceFee } = useResourceHook({});

  const handleAddFee = async (fee: FeeSchema) => {
    if(fee !== undefined){
      await addNewResourceFee(resource?.id as string, fee)
    }
    if(isResourceError){
      toast.error("Error adding fee. Please try again.")
    }else{
      toast.success("Fee added successfully!")
    }
    setIsOpenFee(false);
  }

  const handleAddDiscount = async (discount: DiscountSchema) => {
    if(discount !== undefined){
      const res = await addNewResourceDiscount(resource?.id as string, discount)
      if(res || !isResourceError){
        toast.success("Discount added successfully!")
      } else {
        toast.error("Error adding discount. Please try again.")
      }
    }
    // if(isResourceError){
    //   toast.error("Error adding discount. Please try again.")
    // }
    setIsOpenDiscount(false);
  }


  const handleDeleteDiscountModal = async (discountName: string) => {
    setIsDeletingDiscount({isOpen: true, discountName})
  }

  const handleDeleteFeeModal = async (feeName: string) => {
    setIsDeletingFee({isOpen: true, feeName})
  }

  const handleDeleteFee = async (feeName: string) => {
    if(feeName !== undefined){
      await deleteExistingResourceFee(resource?.id as string, feeName)
    }
    if (isResourceError){
      toast.error("Error deleting fee. Please try again.")
    } else {
      toast.success("Fee deleted successfully!")
    }
    setIsDeletingFee({isOpen: false, feeName: ""})
  }


  const handleDeleteDiscount = async (discountId: string) => {
    if(discountId !== undefined){
      await deleteExistingDiscount(resource?.id as string, discountId)
    }
    if (isResourceError){
      toast.error("Error deleting discount. Please try again.")
    } else {
      toast.success("Discount deleted successfully!")
    }
    setIsDeletingDiscount({isOpen: false, discountName: ""})
    setIsOpenDiscount(false);
  }
  // const {reloadCurrentResource} = useLoadCurrentResource(resourceid)

  const updateResourceData =  async (resource: ResourceSchema): Promise<boolean> => {
    if (resourceid && currentResource){
      var changes = getChangedAttributes(currentResource, resource);

      // console.log("resource id", resourceid)
      // console.log("resource changes", changes)
      if (Object.keys(changes || {})?.length > 0){
        var updated = await updateResource(resourceid, changes);
        if (isResourceError || !updated){
          toast.error("Error updating resource. Please try again.")
          return false;
        } else {
          toast.success("Resource updated successfully!")
          setResource((prev) => ({
            ...(prev || {}),
            ...resource,
          }) as ResourceSchema);
          return true;
        }
      } else {
        toast.error("No changes to update.")
        return false;
      }
    } else {
      toast.error("Error updating resource. Please try again.")
      return false;
    }
  };


  const handleEditPlan = async (planId: string, plan: ResourcePlanSchema) => {
    const isDualPlan = isOpenEditPlan.plan?.plan_type === "dual" || plan.plan_type === "dual"
    let success: boolean
    if (isDualPlan) {
      // Dual plans live in the shared community plans store; update it so both the
      // membership tiers view and this resource booking view reflect the change,
      // then refresh the resource object for its own (non-dual) plan data.
      success = await updateCommunityPlan(planId, { ...plan, plan_type: "dual" })
      await reloadCurrentResource()
    } else {
      success = await updateResourcePlan(planId, plan)
    }
    if(!planId || !success){
      toast.error("Error editing plan. Please try again.")
    } else{
      toast.success("Plan edited successfully!")
    }
    setIsOpenEditPlan({isOpen: false, plan: null});
  }

  const handleAddCustomRequirement = async (req: RequirementSchema) => {
    if(req?.name){
      await addCustomRequirement(req)
    }
    if(isReqError){
      toast.error("Error adding requirement. Please try again.")
    }else{
      toast.success("Requirement added successfully!")
    }
    setIsAddingCustomRequirement(false)
  }

  const handleDelete = () => {
    deleteResource()
    if (isResourceError){
      toast.error("Error deleting resource. Please try again.")
    } else {
      toast.success("Resource deleted successfully!")
    }
    setIsDeletingResource(false)
    navigate(-1)
  }

  const handleCopyLink = async (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent the button's onClick from firing
    const link = `${resourcePantryUrl}/${resourceType}/${resourceid}?home=true`
    try {
      await navigator.clipboard.writeText(link)
      toast.success("Link copied to clipboard!")
    } catch (err) {
      toast.error("Failed to copy link. Please try again.")
    }
  }
  
  useEffect(
    () => {
      document.title = `${resourceType ? capitalizeString(resourceType) : "Resource"} | Details`;
      setResource(currentResource as ResourceSchema)
    }, // eslint-disable-next-line
    [currentResource, resourceName ]
  );


  var resourceManagementOptions: ResourceTabOptionType[] = [
    {
      id: "details",
      name: `${capitalizeString(resourceType)} Details`
    },
    {
      id: "images",
      name: "Images"
    },
  ]

  const isContactListExpert = resourceType === 'expert' && isContactBuilderResource(resource);
  const contactCommunityId = communityId || resource?.community_id || '';

  useEffect(() => {
    if (!isContactListExpert || !contactCommunityId || !resourceid) return;
    let cancelled = false;
    setIsLoadingMemberLists(true);
    listContactProjectSummaries(contactCommunityId, resourceid)
      .then((items: ContactProjectSummary[]) => { if (!cancelled) setMemberLists(items); })
      .catch(() => { if (!cancelled) setMemberLists([]); })
      .finally(() => { if (!cancelled) setIsLoadingMemberLists(false); });
    return () => { cancelled = true; };
  }, [isContactListExpert, contactCommunityId, resourceid]);

  const fundingPartnerSlug = resource?.funding_profile?.partner?.slug;
  const pipelineCount = buildFundingPipelineItems({
    applications: bookings || [],
    resourceId: resourceid,
    partnerSlug: fundingPartnerSlug,
  }).length;

  if (resourceType === 'funding') {
    resourceManagementOptions = [
      { id: 'details', name: 'Fund Details' },
      { id: 'funding_listing', name: 'Listing & eligibility' },
      ...(isFinancialIntelligenceResource(resource) ? [{ id: 'funding_partner' as const, name: 'Partner setup' }] : []),
      { id: 'plans', name: 'Rates' },
      { id: 'images', name: 'Images' },
      { id: 'requests', name: `Pipeline (${pipelineCount})` },
    ] as ResourceTabOptionType[];
  } else if ("kitchen" === resourceType){
    resourceManagementOptions = [
      ...resourceManagementOptions, 
      {
        id: "requirements",
        name: "Credential Requirements"
      },
      {
        id: "plans",
        name: "Booking Plans"
      },
      {
        id: "fees",
        name: "Fees"
      },
      {
        id: "discounts",
        name: "Discounts"
      },
      {
        id: "rules",
        name: "Rules"
      },
      {
        id: "partner_setup",
        name: "Partner setup"
      },
    ]
  }

  if (resourceType !== 'funding' && ["kitchen", "training", "farm", "expert"].includes(resourceType)){
    resourceManagementOptions = [
      ...resourceManagementOptions, 
      {
        id: "items",
        name: (["training", "expert"].includes(resourceType)) ? "Schedules" : "Inventory"
      }
    ]
  }

  if (resourceType !== 'funding') {
    if ("documentation" === resourceType){
      resourceManagementOptions = [
        ...resourceManagementOptions, 
        {
          id: "steps",
          name:  "Steps"
        },
        {
          id: "partner_setup",
          name: "Partner setup"
        },
        {
          id: "requests",
          name: `Applicants (${bookings && bookings?.length > 0 ? bookings?.length : 0})`
        }
      ]
    } else {
      // Non-kitchen types that did not already get Partner setup in the kitchen branch.
      if (resourceType !== 'kitchen' && !resourceManagementOptions.some((opt) => opt.id === 'partner_setup')) {
        resourceManagementOptions = [
          ...resourceManagementOptions,
          { id: 'partner_setup', name: 'Partner setup' },
        ];
      }
      if (resourceType === 'expert' && isContactBuilderResource(resource)) {
        resourceManagementOptions = [
          ...resourceManagementOptions,
          { id: 'contact_lists', name: 'Contact lists' },
        ];
      }
      resourceManagementOptions = [
        ...resourceManagementOptions, 
        {
          id: "requests",
          name: `${capitalizeString(resourceType)} Requests (${isContactListExpert ? memberLists.length : (bookings && bookings?.length > 0 ? bookings?.length : 0)})`
        }
      ]
    }
  }


  

  const { getResourceIconData } = useLoadResourceOptions()

  const resourceCategory = getResourceIconData(resourceType).name

  // const { updateOptions } = useKitchenHook()


  const updateResourceOptions = async (updateData: ResourceOptionsPropsType) => {
    // console.log("updateResourceOptions updateData", updateData)
    if (resourceid && currentResource){

      const { resourceOptions, selectedDays } = updateData

      // console.log("resourceOptions 1", resourceOptions)
      // console.log("selectedDays", selectedDays)

      for (const day in selectedDays) {
        let resourceOption = resourceOptions[day as WeekdayOptionFields]
        if (!selectedDays[day] && resourceOption && resourceOptions[day as WeekdayOptionFields]){
          delete resourceOptions[day as WeekdayOptionFields]
        }
      }

      // console.log("resourceOptions 2", resourceOptions)

      if (resourceOptions !== undefined){
        // remove non-operating hours
        if (resourceOptions?.equipments) {delete resourceOptions['equipments']}
        if (resourceOptions?.services) {delete resourceOptions['services']}
        if (resourceOptions?.features) {delete resourceOptions['features']}
        if (resourceOptions?.last_updated) {delete resourceOptions['last_updated']}
        // console.log("resourceOptions 3", resourceOptions)
        
        updateOptions(resourceid, resourceOptions)
        if (isResourceError){
          toast.error("Error updating resource. Please try again.")
        } else {
          toast.success("Resource updated successfully!")
        }
      }
    }
  };

  /** Renders the active manage-resource tab panel. */
  const renderResourceTabContent = () => {
    if (currentOption.id === 'images') {
      return (
        <ResourceImagesForm
          resourceType={resourceType}
          resource={resource}
          updateResourceData={updateResourceData}
          currentResource={currentResource as ResourceSchema}
        />
      );
    }

    if (currentOption.id === 'plans') {
      return (
        <ResourcePlans
          resource={currentResource as ResourceSchema}
          resourceId={resourceid}
          resourcePlans={currentResource?.plans as ResourcePlanSchema[]}
          resourceType={resourceType}
          openAddModal={() => setIsOpenPlan(true)}
          openDuplicateModal={(plan: ResourcePlanSchema) => setIsDuplicate({ existingPlan: plan, checked: true })}
          openEditModal={(plan: ResourcePlanSchema) => setIsOpenEditPlan({ isOpen: true, plan })}
        />
      );
    }

    if (currentOption.id === 'requirements') {
      return (
        <ResourceRequirementsForm
          resourceId={resourceid}
          resourceRequirements={currentResource?.requirements as RequirementSchema[]}
          communityRequirements={requirements}
          setIsAddingCustomRequirement={setIsAddingCustomRequirement}
        />
      );
    }

    if (currentOption.id === 'discounts') {
      return (
        <ResourceDiscountsForm
          resourceId={currentResource?.id as string}
          resourceDiscounts={currentResource?.discounts as DiscountSchema[]}
          setIsOpenDiscount={setIsOpenDiscount}
          handleDeleteDiscount={handleDeleteDiscountModal}
        />
      );
    }

    if (currentOption.id === 'requests') {
      if (resourceType === 'documentation') {
        return (
          <DocumentationApplicantsPanel
            resource={currentResource as ResourceSchema}
            resourceId={resourceid}
            resourceType={resourceType}
            bookings={bookings || []}
          />
        );
      }
      if (resourceType === 'funding') {
        return (
          <FundingPipelinePanel
            resourceType={resourceType}
            resourceRequests={bookings || []}
            resourceId={resourceid}
            partnerSlug={fundingPartnerSlug}
          />
        );
      }
      if (isContactListExpert) {
        return (
          <DscvryMemberRequests
            projects={memberLists}
            loading={isLoadingMemberLists}
            onOpen={(projectId) => {
              setOpsProjectId(projectId);
              setCurrentOption({ id: 'contact_lists', name: 'Contact lists' } as CommunityOptionType);
            }}
          />
        );
      }
      return <AllResourceRequests resourceType={resourceType} resourceRequests={bookings || []} />;
    }

    if (currentOption.id === 'steps') {
      return (
        <DocumentationStepsPanel
          resource={currentResource as ResourceSchema}
          resourceId={resourceid}
          resourceType={resourceType}
        />
      );
    }

    if (currentOption.id === 'items') {
      return (
        <ResourceProductDetails
          resourceType={resourceType}
          resource={resource}
          updateResourceData={updateResourceData}
        />
      );
    }

    if (currentOption.id === 'fees') {
      return (
        <ResourceFeesForm
          resourceId={currentResource?.id as string}
          resourceFees={currentResource?.fees as FeeSchema[]}
          setIsOpenFee={setIsOpenFee}
          handleDeleteFeeModal={handleDeleteFeeModal}
        />
      );
    }

    if (currentOption.id === 'rules') {
      return (
        <ResourceRulesForm
          resourceId={currentResource?.id as string}
          resourceRules={currentResource?.rules || []}
        />
      );
    }

    if (currentOption.id === 'contact_lists') {
      return (
        <ContactBuilderOps
          communityId={contactCommunityId}
          resourceId={resourceid}
          resource={resource}
          initialProjectId={opsProjectId}
        />
      );
    }

    if (currentOption.id === 'funding_listing') {
      return (
        <ResourceInfoForm
          resourceType={resourceType}
          resource={resource}
          updateResourceData={updateResourceData}
          updateResourceOptions={updateResourceOptions}
          section="funding_listing"
        />
      );
    }

    if (currentOption.id === 'funding_partner' || currentOption.id === 'partner_setup') {
      return (
        <ResourceInfoForm
          resourceType={resourceType}
          resource={resource}
          updateResourceData={updateResourceData}
          updateResourceOptions={updateResourceOptions}
          section={currentOption.id === 'funding_partner' ? 'funding_partner' : 'partner_setup'}
        />
      );
    }

    return (
      <>
        {resourceType === 'funding' && isFinancialIntelligenceResource(resource) ? (
          <>
            <ResourceInfoForm
              resourceType={resourceType}
              resource={resource}
              updateResourceData={updateResourceData}
              updateResourceOptions={updateResourceOptions}
              section='core'
            />
            {isAiriWheelsResource(resource) && (
              <div className="mx-auto mb-6 w-11/12">
                <PilotScorecard
                  communityId={communityId || resource.community_id}
                  resourceId={resourceid}
                  partnerSlug={resource.funding_profile?.partner?.slug || 'airiwheels'}
                />
              </div>
            )}
            {/* Offer summary above edit form; Day-90 scorecard stays below. */}
            <FinancialIntelligenceOfferBand resource={resource} />
          </>
        ) : (
          <ResourceInfoForm
            resourceType={resourceType}
            resource={resource}
            updateResourceData={updateResourceData}
            updateResourceOptions={updateResourceOptions}
            section={resourceType === 'funding' ? 'core' : 'full'}
          />
        )}
      </>
    );
  };

  if (isLoadingResource){
    return (
      <LoadingScreen bgColor="white" height="h-auto" />
    )
  }

  return (
    <>
      <div className="flex flex-row bg-white h-[68px] mt-[72px] w-full">
        <button 
            className="flex flex-row mx-8  h-[40px] w-[40px] rounded-full border-[1px] border-[#E9E9E9] font-raleway text-[16px] text-[#8A8A8A] my-auto p-2"
            onClick={()=> navigate(-1)}
        >
            <BackButtonIcon  className="m-auto"/> 
            {/* <p className="my-auto mx-1">Go Back</p> */}
        </button>
        <p className="text-[#808080] font-raleway text-[20px] my-auto mx-2">
          {resourceCategory} 
          &nbsp;/&nbsp;
          {currentResource?.name ? currentResource.name : ""}
          &nbsp;/&nbsp;
          <span className="text-primary-200 font-bold">Manage {capitalizeString(resourceType)}</span>
        </p>
        {/* <div className="flex flex-row ml-auto ">
          <button className="mx-2 font-raleway text-[16px] text-primary-200 font-medium my-auto border-[1px] border-[#E9E9E9] p-2 rounded-lg">Go to Resource Pantry</button>
        </div> */}
        <div className="flex flex-row ml-auto mx-16">
          <button onClick={()=>window.open(`${resourcePantryUrl}/${resourceType}/${resourceid}?home=true`, "_blank")} className="flex flex-row mx-2 font-raleway text-[16px] text-primary-200 font-medium my-auto border-[1px] border-[#E9E9E9] p-2 rounded-lg">
            <div
              onClick={handleCopyLink}
              className="my-auto ml-2 mr-1 hover:opacity-70 transition-opacity cursor-pointer"
              title="Copy link"
            >
              <CopyIcon className="text-primary-200/80" style={{height: 16, width: 16}} />
            </div>
            <p className="my-auto mx-2 hover:opacity-70 transition-opacity cursor-pointer text-primary-200">Go to Resource Pantry</p>
            <ArrowOutward className="my-auto font-semibold hover:opacity-70 transition-opacity cursor-pointer text-primary-200 mr-1" style={{height: 16, width: 16}} />
          </button>
          <button onClick={()=>setIsDeletingResource(true)} className="mx-2 font-raleway text-[16px] text-[#D42620] font-medium my-auto border-[1px] border-[#E9E9E9] p-2 rounded-lg">Delete {resourceCategory}</button>
        </div>
      </div>
      <div className="flex flex-row bg-white h-[75px] border-[#E9E9E9] border-[1px] w-full">
        <span className="flex flex-row mx-16">
        {
          resourceManagementOptions.map((option: CommunityOptionType, i: number) => {
            return (
              <div 
                key={i} 
                onClick={()=>setCurrentOption(option)} 
                className={`${(currentOption.id === option.id) ? 'text-white bg-primary-200' : 'text-[#4D4D4D] '} mr-4 my-auto text-[13px] font-raleway border-[1px] border-[#E9E9E9] py-2 px-4 rounded-md cursor-pointer`}
              >
                  {option.name}
              </div>
            )
          })
        }
        </span>
      </div>

      <div className="w-full min-h-[calc(100vh-215px)] bg-surface-canvas pb-8">
        {isLoadingResource ? <LoadingScreen /> : renderResourceTabContent()}
      </div>
      {/* {
        (currentResource && <AddPlanModal
          resource={currentResource}
          isOpen={isOpenAddPlan}
          closeAppModal={() => setIsOpenPlan(false)}
          />
        )
      } */}

      {
        (currentResource && <AddResourcePlanModal
          resource={currentResource}
          isOpen={isOpenAddPlan || isDuplicate.checked}
          closeAppModal={() => {
            setIsOpenPlan(false)
            setIsDuplicate({existingPlan: {} as ResourcePlanSchema, checked: false})
          }}
          isDuplicate={isDuplicate}
          />
        )
      }
      {
        (currentResource && <EditResourcePlanModal
          resource={currentResource}
          isOpen={isOpenEditPlan.isOpen}
          existingPlan={isOpenEditPlan.plan as ResourcePlanSchema}
          closeAppModal={() => setIsOpenEditPlan({isOpen: false, plan: null})}
          handleEditPlan={handleEditPlan}
          />
        )
      }
      {
        (currentResource && <AddFeeModal
          resource={currentResource}
          isOpen={isOpenFee}
          handleAddFee={handleAddFee}
          closeAppModal={() => setIsOpenFee(false)}
          />
        )
      }
      {
        (currentResource && <AddDiscountModal
          isOpen={isOpenDiscount}
          currentResource={currentResource}
          handleAddDiscount={handleAddDiscount}
          closeAppModal={() => setIsOpenDiscount(false)}
          />
        )
      }
      <AddRequirementModal
        isOpen={isAddingCustomRequirement}
        closeAppModal={() => setIsAddingCustomRequirement(false)}
        handleAddCustomRequirement={handleAddCustomRequirement}
      />


      {
        (isDeletingResource && <DeleteConfirmationModal dataName="resource" isOpen={isDeletingResource} data={currentResource} handleDelete={handleDelete} closeDeleteModal={()=>setIsDeletingResource(false)} />)
      }

      {
        (isDeletingDiscount.isOpen && <DeleteConfirmationModal dataName="discount" isOpen={isDeletingDiscount.isOpen} data={{id: isDeletingDiscount.discountName, item_name: isDeletingDiscount.discountName}} handleDelete={handleDeleteDiscount} closeDeleteModal={()=>setIsDeletingDiscount({isOpen: false, discountName: ""})} />)
      }

      {
        (isDeletingFee.isOpen && <DeleteConfirmationModal dataName="fee" isOpen={isDeletingFee.isOpen} data={{id: isDeletingFee.feeName, item_name: isDeletingFee.feeName}} handleDelete={handleDeleteFee} closeDeleteModal={()=>setIsDeletingFee({isOpen: false, feeName: ""})} />)
      }
    </> 
  )
}


type FinancialIntelligenceOfferBandProps = {
  resource: ResourceSchema
};

/**
 * Collapsible FI offer summary above the resource edit form.
 * Stays above ResourceInfoForm; PilotScorecard renders separately below for AiriWheels.
 */
const FinancialIntelligenceOfferBand: FC<FinancialIntelligenceOfferBandProps> = ({ resource }) => {
  const [expanded, setExpanded] = useState(true);
  const profile = resource.funding_profile;
  const fulfillmentLabel = FULFILLMENT_MODE_OPTIONS.find((option) => option.value === profile?.fulfillment_mode)?.label;
  const partnerName = getPartnerDisplayName(resource);

  return (
    <div
      className="relative mx-auto mb-6 w-11/12 overflow-hidden partner-section-card px-6 py-5 sm:px-8"
      data-testid="funding-intelligence-details"
    >
      <div aria-hidden className="pointer-events-none absolute inset-y-0 left-0 w-[6px] bg-primary-400" />
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-tint px-3 py-1 font-raleway text-[11px] font-bold uppercase tracking-[0.12em] text-primary-100">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary-400" />
            Financial intelligence
          </span>
          <h3 className="mt-3 font-raleway text-xl font-bold leading-tight text-ink sm:text-2xl">
            {partnerName}
          </h3>
          {!expanded && profile?.pricing_summary && (
            <p className="mt-1 font-raleway text-sm font-semibold text-primary-100">
              {profile.pricing_summary}
            </p>
          )}
        </div>
        <button
          type="button"
          aria-expanded={expanded}
          aria-controls="fi-offer-band-body"
          onClick={() => setExpanded((open) => !open)}
          className="inline-flex h-10 shrink-0 items-center gap-1 rounded-lg border border-[#E4EEF1] bg-white px-3 font-raleway text-sm font-semibold text-ink transition-colors hover:border-primary-400/50 hover:bg-primary-tint"
          data-testid="funding-intelligence-offer-toggle"
        >
          {expanded ? 'Hide offer' : 'Show offer'}
          {expanded ? <ExpandLess style={{ height: 18, width: 18 }} /> : <ExpandMore style={{ height: 18, width: 18 }} />}
        </button>
      </div>
      {expanded && (
        <div id="fi-offer-band-body" className="mt-5 grid gap-6 lg:grid-cols-[minmax(0,1.15fr)_minmax(280px,0.85fr)] lg:items-start">
          <div className="min-w-0">
            {profile?.pricing_summary && (
              <p className="font-raleway text-base font-semibold text-primary-100">
                {profile.pricing_summary}
              </p>
            )}
            {profile?.eligibility?.notes && (
              <p className="mt-4 max-w-2xl font-open-sans text-[15px] leading-relaxed text-[#3F5B64]">
                {profile.eligibility.notes}
              </p>
            )}
          </div>
          <div className="rounded-xl border border-[#E4EEF1] bg-[#F8FCFD] p-5">
            <p className="page-kicker mb-3">Capabilities</p>
            <div className="flex flex-wrap gap-2">
              {(profile?.wheels || []).map((wheel) => (
                <span
                  key={wheel}
                  className="rounded-full border border-[#E4EEF1] bg-white px-3 py-1.5 text-xs font-raleway font-semibold text-ink"
                >
                  {FINANCIAL_WHEEL_OPTIONS.find((option) => option.value === wheel)?.label || wheel}
                </span>
              ))}
            </div>
            {fulfillmentLabel && (
              <p className="mt-4 text-sm font-open-sans leading-relaxed text-[#3F5B64]">
                <span className="font-semibold text-ink">Fulfillment: </span>
                {fulfillmentLabel}
              </p>
            )}
            {profile?.partner?.signup_url && (
              <a
                href={profile.partner.signup_url}
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-flex h-11 items-center gap-1.5 rounded-lg border border-primary-400/50 bg-white px-4 font-raleway text-sm font-semibold text-primary-300 transition-colors hover:border-primary-400 hover:bg-primary-tint"
              >
                Partner site
                <ArrowOutward style={{ height: 16, width: 16 }} />
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResourceDetails;






type ResourcePlansProps = {
  resource?: ResourceSchema
  resourceId: string
  resourcePlans: ResourcePlanSchema[]
  resourceType: ResourceType
  openAddModal: () => void
  openDuplicateModal: (plan: ResourcePlanSchema) => void
  openEditModal: (plan: ResourcePlanSchema) => void
}

type FundingRatePlanCardProps = {
  plan: ResourcePlanSchema
  trialDays?: number
  openEditModal: (plan: ResourcePlanSchema) => void
  openDeleteModal: () => void
}

/**
 * Compact rate card for funding listings. A funding offer prices a recurring access fee,
 * so this shows only the rate, cadence, trial, and what the fee includes.
 */
const FundingRatePlanCard: React.FC<FundingRatePlanCardProps> = ({plan, trialDays, openEditModal, openDeleteModal}) => (
  <div data-testid="funding-rate-plan-card" className="flex flex-col bg-white mx-2 my-4 rounded-lg overflow-hidden">
    <div className="m-[24px] text-black font-raleway text-[20px] font-medium">
      <div className="flex flex-row items-center">
        <p className="my-auto font-semibold">{plan.plan_name}</p>
        {trialDays ? (
          <span className="ml-3 rounded-2xl bg-[#EFF8FA] px-3 py-1 font-raleway text-[13px] font-medium text-primary-300">
            {trialDays}-day trial
          </span>
        ) : null}
      </div>
      {plan.plan_description && (
        <p className="text-[#4D4D4D]/70 text-[14px] font-normal font-open-sans mt-1">{plan.plan_description}</p>
      )}
    </div>
    <hr className="border-[#E9E9E9] b-0 border-b-[1px]" />
    <div className="flex flex-row m-[24px] gap-x-2">
      <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/2">
        <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway">
          Access Fee
        </p>
        <p className="text-[18px] font-raleway font-semibold">
          ${styleThousandCommas(plan.plan_rate || 0)}{' '}
          <span className="text-black/80 text-[14px] font-medium font-raleway">
            / {planRecurrenceMap[plan.plan_recurrence as PlanRecurrenceOptions]}
          </span>
        </p>
      </div>
      {plan.overage_rate ? (
        <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/2">
          <p className="text-[#808080] text-[14px] font-medium font-raleway">Overage</p>
          <p className="text-[18px] font-raleway font-semibold">
            ${styleThousandCommas(plan.overage_rate)}
          </p>
        </div>
      ) : null}
    </div>
    {(plan.features && plan.features.length > 0) && (
      <div className="mx-[24px] mb-[24px] flex flex-col gap-y-1">
        <p className="text-[#808080] text-[14px] font-medium font-raleway mb-1">Plan Features</p>
        {plan.features.map((feature: string, featureIndex: number) => (
          <p key={featureIndex} className="flex flex-row font-open-sans text-[14px] text-black">
            <CheckCircle className="my-auto mr-1 text-primary-400 shrink-0" style={{height: 16, width: 16}} />
            {feature}
          </p>
        ))}
      </div>
    )}
    <div className="flex w-full mt-auto bg-primary-200 text-white h-[75px] font-raleway rounded-b-lg">
      <button
        className="flex flex-row mr-auto my-auto mx-[24px] font-medium"
        onClick={openDeleteModal}
      >
        <DeleteIcon className="my-auto mr-1 text-white" />
        Delete Rate
      </button>
      <button
        className="flex flex-row bg-white text-primary-200 border-[1px] border-primary-200 rounded-md ml-auto my-auto mx-[24px] font-medium p-2"
        onClick={() => openEditModal(plan)}
      >
        <EditIcon className="my-auto mr-1 text-primary-200" style={{height: 16, width: 16}} />
        Edit Rate
      </button>
    </div>
  </div>
);

const ResourcePlans: React.FC<ResourcePlansProps> = ({resource, resourceId, resourcePlans,resourceType, openAddModal, openDuplicateModal, openEditModal}) => {

  const inventoryItemsById = useMemo(
    () => buildInventoryItemsByIdFromResources(resource ? [resource] : []),
    [resource]
  );

  const { plans: communityPlans } = useLoadPlans()

  /** Funding listings price an offer rather than a booking slot, so the noun differs. */
  const isFundingResource = resourceType === 'funding'
  const planNoun = isFundingResource ? 'Rate Plan' : 'Booking Plan'

  /**
   * Merge this resource's booking plans with any dual membership tiers linked to it.
   * Dual tiers are sourced from the shared community plans query so edits made in the
   * membership tier forms stay in sync here without a separate resource reload.
   */
  const displayPlans = useMemo<ResourcePlanSchema[]>(
    () => mergeResourcePlansWithDualTiers(resourcePlans, communityPlans, resourceId),
    [resourcePlans, communityPlans, resourceId]
  )

  const { deletePlan, reloadCurrentResource } = useResourceHook({resourceId, resourceType})
  type DeletePlanType = {status: boolean, plan: ResourcePlanSchema}
  const [isDeleting, setIsDeleting] = useState<DeletePlanType>({status: false, plan: {} as ResourcePlanSchema})
  const handleDelete = async (planId: string) => {
    if (planId){
      const success = await deletePlan(planId, "resource")
      if (success){
        await reloadCurrentResource()
        toast.success("Plan deleted successfully!")
      }
      else{
        toast.error("Error deleting plan. Please try again.")
      }
    }
    setIsDeleting({status: false, plan: {} as ResourcePlanSchema})
  }

  useEffect(() => {
    document.title = "HomeCook | Resource Plans";
  }, [resourcePlans]);

  return (
    (displayPlans && displayPlans.length > 0 ) ? (
      <>
        <div className="flex flex-row mx-auto w-11/12">
          <button 
            className="bg-primary-200 font-medium text-[16px] font-raleway text-white px-3 py-2 rounded-md mt-2 mx-2 w-auto  ml-auto"
            onClick={openAddModal}
          >
            <AddCircle className="my-auto mx-2 text-white" style={{height: 20, width: 20}} />
            Add {planNoun}
          </button>
        </div>
        <div className="grid grid-cols-2 grid-flow-dense w-11/12 mx-auto">
          {
            isFundingResource ? displayPlans.map((plan: ResourcePlanSchema, i: number) => (
              <FundingRatePlanCard
                key={plan.plan_id || i}
                plan={plan}
                trialDays={resource?.funding_profile?.trial_days}
                openEditModal={openEditModal}
                openDeleteModal={() => setIsDeleting({status: true, plan})}
              />
            )) : displayPlans.map((plan: ResourcePlanSchema, i: number) => (
              <div key={i} className="flex flex-col h-[550px] bg-white mx-2 my-4 rounded-lg">
                <div className="m-[24px] text-black font-raleway text-[20px] font-medium">
                  <div className="flex flex-row">
                      <p className="my-auto font-semibold">{plan.plan_name} </p> 
                      {plan.plan_type !== "dual" && (<span className={`flex flex-row ml-6 ${plan.pricing_type === "dynamic" ? "text-primary-400  bg-[#EFF8FA]" : "text-primary-300 bg-[#EFF8FA]/80"} font-medium my-auto text-[14px] font-raleway rounded-2xl px-3 py-2`}>
                        <TagIcon className="my-auto mr-1 " style={{height: 16, width: 16}} /> 
                        {capitalizeString(plan.pricing_type || "")} Pricing
                      </span>)}
                      {plan.plan_type === "dual" && (
                        <span className="flex flex-row ml-3 text-[#5C4D8A] bg-[#F3EFFF] font-medium my-auto text-[14px] font-raleway rounded-2xl px-3 py-2">
                          <Layers className="my-auto mr-1" style={{height: 16, width: 16}} />
                          Member Tier
                        </span>
                      )}
                      {planShowsFulltimeHoursBadge(plan) && (
                        <span className="flex flex-row ml-3 items-center text-[#0F766E] bg-[#ECFDF5] font-medium my-auto text-[14px] font-raleway rounded-2xl px-3 py-2">
                          <ClockIcon className="my-auto mr-1 shrink-0" style={{ height: 16, width: 16 }} />
                          24/7 Access
                        </span>
                      )}
                      <span onClick={()=> openDuplicateModal(plan)} className="flex flex-row ml-auto text-[#808080]/50 my-auto text-[13px] font-raleway cursor-pointer">
                        <CopyIcon className="my-auto mr-1 " style={{height: 16, width: 16}} /> 
                        Duplicate Plan
                      </span>
                  </div>
                  {
                    (plan.plan_description && plan.plan_description.length > 0) && (
                      <p className="text-[#4D4D4D]/70 text-[14px] font-normal font-open-sans mt-1">{capitalizeString(plan.plan_description)}</p>
                    )
                  }
                </div>
                <hr className="border-[#E9E9E9] b-0 border-b-[1px]" />
                <div className="flex flex-row m-[24px] gap-x-2">
                  <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway"><PlanIcon className={`${getPeriodStyles("STANDARD").text} my-auto mr-1`} style={{height: 16, width: 16}} /> Standard Rate</p>
                    <p className="text-[18px] font-raleway font-semibold">${styleThousandCommas(plan.plan_rate || 0)} <span className="text-black/80 text-[14px] font-medium font-raleway">/ {planRecurrenceMap[plan.plan_recurrence as PlanRecurrenceOptions]}</span></p>
                  </div>
                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" /> */}
                  {/* <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway"><ClockIcon className="my-auto mr-1 text-primary-400" style={{height: 16, width: 16}} /> Frequency</p>
                    <p className="text-[18px] font-raleway font-semibold">{capitalizeString((plan && plan?.plan_recurrence) ? plan.plan_recurrence : "N/A")}</p>
                  </div> */}
                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" /> */}
                  {(plan && plan?.plan_max_hours) ? (<div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway">
                      <ClockIcon className="my-auto mr-1 text-primary-400" style={{height: 16, width: 16}} />
                      {(["weekly", "monthly", "annual"].includes(plan.plan_recurrence as any)) ? "Max Days" : "Max Hours"}
                    </p>
                    <p className="text-[18px] font-raleway font-semibold">
                      {(["weekly", "monthly", "annual"].includes(plan.plan_recurrence as any)) 
                        ? Math.floor((plan.plan_max_hours || 0) / 24) 
                        : (plan.plan_max_hours || 0)
                      }
                    </p>
                  </div>) : (<></>)}

                  {(plan && plan?.plan_max_hours && plan?.overage_rate ) ? (<div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway"><PlanIcon className="my-auto mr-1 text-primary-400" style={{height: 16, width: 16}} /> Overage Rate</p>
                    <p className="text-[18px] font-raleway font-semibold">${styleThousandCommas(plan.overage_rate || 0)} <span className="text-black/80 text-[14px] font-medium font-raleway">/ hour</span></p>
                  </div>) : (<></>)}

                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" />
                  <div className="flex flex-col">
                    <p className="text-[#808080] text-[16px] font-raleway">Capacity</p>
                    <p className="text-[16px] font-open-sans">0 Members</p>
                  </div> */}

                </div>
                <div className="flex flex-row mx-[24px] mb-[24px] gap-x-2">
                  <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className={`flex flex-row text-[#808080] text-[14px] font-medium font-raleway ${plan.pricing_type === "dynamic" ? "" : "opacity-30"} pointer-events-none`}>
                      <PlanIcon className={`${getPeriodStyles("OFF_PEAK").text} my-auto mr-1`} style={{height: 16, width: 16}} /> 
                      Off-Peak Rate
                    </p>
                    {
                      (plan.pricing_type === "dynamic") ? (<p className="text-[18px] font-raleway font-semibold">${styleThousandCommas(plan.off_peak_rate || 0)} <span className="text-black/80 text-[14px] font-medium font-raleway">/ {planRecurrenceMap[plan.plan_recurrence as PlanRecurrenceOptions]}</span></p>)
                      : (
                        <p className="text-[18px] opacity-30 font-raleway font-semibold">-</p>
                      )
                    }
                  </div>
                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" /> */}
                  <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className={`flex flex-row text-[#808080] text-[14px] font-medium font-raleway ${plan.pricing_type === "dynamic" ? "" : "opacity-30"} pointer-events-none`}>
                      <PlanIcon className={`${getPeriodStyles("PEAK").text} my-auto mr-1`} style={{height: 16, width: 16}} /> 
                      Peak Rate
                    </p>
                    {
                      (plan.pricing_type === "dynamic") ? (<p className="text-[18px] font-raleway font-semibold">${styleThousandCommas(plan.peak_rate || 0)} <span className="text-black/80 text-[14px] font-medium font-raleway">/ {planRecurrenceMap[plan.plan_recurrence as PlanRecurrenceOptions]}</span></p>)
                      : (
                        <p className="text-[18px] opacity-30 font-raleway font-semibold">-</p>
                      )
                    }
                 </div>
                  {/* <div className="w-[2px] h-[32px] bg-[#E9E9E9] mx-auto" /> */}
                  <div className="flex flex-col bg-[#FAFAFA] rounded-md p-4 w-1/3">
                    <p className="flex flex-row text-[#808080] text-[14px] font-medium font-raleway opacity-30 pointer-events-none"><CommunityIcon className="my-auto mr-1 text-primary-400" style={{height: 18, width: 18}} /> Members</p>
                    <p className="text-[18px] font-raleway font-semibold opacity-30">
                      {/* {memberCountPerPlan(bookings || [])} */}
                      -
                    </p>
                  </div>
                </div>
                <div className="flex flex-col mx-[24px] flex-1 min-h-0 overflow-y-auto pb-2">
                  <p className="text-[#808080] text-[14px] mb-1 font-medium font-raleway">Plan Features</p>
                  {
                    planHasDisplayFeatures(plan.features, plan.associated_resources) ? (
                      <>
                        {plan.features && plan.features.map((feature: string, featureIndex: number) => (
                          <p key={`feature-${featureIndex}`} className="flex flex-row text-[16px] font-open-sans font-normal text-black">
                            <CheckCircle className="my-auto mr-1 text-primary-400 shrink-0" style={{height: 16, width: 16}} />
                            {feature}
                          </p>
                        ))}
                        {plan.associated_resources?.flatMap((association, associationIndex) =>
                          (association.inventory || []).map((selection, inventoryIndex) => (
                            <p
                              key={`inventory-${associationIndex}-${selection.inventory_id}-${inventoryIndex}`}
                              className="flex flex-row items-center text-[15px] font-open-sans font-normal text-black ml-0"
                            >
                              <KitchenIcon className="my-auto mr-2 text-primary-400 shrink-0" style={{height: 14, width: 14}} />
                              <span className="truncate">{getInventorySelectionLabel(selection, inventoryItemsById)}</span>
                              {selection.max_qty > 0 && (
                                <span className="text-[#808080] text-[13px] ml-1 shrink-0">
                                  · max {selection.max_qty}
                                </span>
                              )}
                            </p>
                          ))
                        )}
                      </>
                    ) : (
                      <p className="flex flex-row text-[14px] font-open-sans font-normal text-black"> No features yet</p>
                    )
                  }
                </div>

                <div className="flex w-full mt-auto bg-primary-200 text-white h-[75px] font-raleway rounded-b-lg">
                  <button 
                    className="flex flex-row mr-auto my-auto mx-[24px] font-medium"
                    onClick={()=> setIsDeleting({status: true, plan: plan})}
                  >
                    <DeleteIcon className="my-auto mr-1 text-white" />
                    Delete Plan
                  </button>

                  <button 
                    className="flex flex-row bg-white text-primary-200 border-[1px] border-primary-200 rounded-md ml-auto my-auto mx-[24px] font-medium p-2"
                    onClick={()=> openEditModal(plan)}
                  >
                    <EditIcon className="my-auto mr-1 text-primary-200" style={{height: 16, width: 16}} />
                    Edit Plan
                  </button>
                </div>
              </div>
            ))
          }
        </div>
        {
          ((isDeleting?.status && isDeleting?.plan?.plan_id) && <DeleteConfirmationModal dataName="plan" isOpen={isDeleting.status} data={{...isDeleting.plan, id: isDeleting.plan?.plan_id, item_name: isDeleting.plan?.plan_name}} handleDelete={handleDelete} closeDeleteModal={()=>setIsDeleting({status: false, plan: {} as ResourcePlanSchema})} />)
        }
      </>
    ) : (
      <div className="flex w-[423px] h-[350px] bg-white m-auto my-[48px] rounded-lg">
        <div className="flex flex-col m-auto w-9/12">
          <div className="flex mx-auto rounded-full h-[80px] w-[80px] bg-[#EFF8FA] mt-auto">
            <KitchenIcon className="m-auto text-primary-400 h-[40px] w-[40px]" />
          </div>
          <p className="font-semibold font-raleway text-[20px] text-primary-200 text-center mt-4">
            No {planNoun} Yet
          </p>
          <p className="text-[#333333] font-open-sans text-[16px] text-center my-3">
            {resourceType === 'funding'
              ? 'Add a rate to generate the pricing summary members see'
              : `Set up a booking plan for your ${resourceType ? resourceType : 'resource'}`}
          </p>
          <button 
            className="bg-primary-200 text-white w-full p-2 rounded-md my-2 font-raleway text-[16px] font-medium"
            onClick={openAddModal}
          >
            <AddCircle className="my-auto mx-2 text-white" style={{height: 24, width: 25}} />
            Add {planNoun}
          </button>
        </div>
      </div>
    )
  )
}

